import { Query } from '@apollo/client/react/components';
import * as React from 'react';
import { ApolloError } from '@apollo/client';

import ACTIVE_GROUPS_QUERY from 'groups/containers/GroupList/queries/ActiveGroupsQuery.gql';

import type {
  ActiveGroupsQuery,
  ActiveGroupsQueryVariables,
  ActiveGroupsQuery_organizations_classes_classes,
} from 'groups/containers/GroupList/queries/__generated__/ActiveGroupsQuery';
import OWNED_GROUP_SUMMARIES_QUERY from 'groups/queries/LoadOwnedGroupSummariesQuery.gql';
import {
  LoadOwnedGroupSummaries,
  LoadOwnedGroupSummaries_me_classes,
} from 'groups/queries/__generated__/LoadOwnedGroupSummaries';

export type Props = {
  orgUuid?: string;
  getOwnedGroups?: boolean;
  query: string;
  children: (props: {
    groups?:
      | ActiveGroupsQuery_organizations_classes_classes[]
      | LoadOwnedGroupSummaries_me_classes[];
    loading: boolean;
    error?: ApolloError;
  }) => JSX.Element;
};

export default function OwnedGroupSummariesFetcher(props: Props) {
  const variables = {
    first: 100,
    query: props.query,
    after: null,
    sortType: 'name',
    sortDirection: 'asc',
    orgUuid: props.orgUuid || '',
  };

  if (props.getOwnedGroups) {
    return (
      <Query<LoadOwnedGroupSummaries> query={OWNED_GROUP_SUMMARIES_QUERY}>
        {({ loading, error, data }) => {
          const groups = (data && data.me && data.me.classes) || undefined;
          const ownedGroups =
            groups &&
            groups.filter<LoadOwnedGroupSummaries_me_classes>(
              (group): group is LoadOwnedGroupSummaries_me_classes =>
                !!group && group.type === 'owned'
            );
          return props.children({ groups: ownedGroups, loading, error });
        }}
      </Query>
    );
  }

  return (
    <Query<ActiveGroupsQuery, ActiveGroupsQueryVariables>
      query={ACTIVE_GROUPS_QUERY}
      variables={variables}
    >
      {({ loading, error, data }) => {
        const groups = data?.organizations?.[0]?.classes?.classes || undefined;
        return props.children({ groups, loading, error });
      }}
    </Query>
  );
}
